export default __webpack_public_path__ + "394fd65447b52fb24a9b9f565a0897cd.png";